/**
 * Constants and enums for BalanceBoosterMultiplier component
 */

/**
 * Currency fallback used before the multipliers API response has loaded
 */
export const FALLBACK_CURRENCY_CODE = "GBP";

/**
 * Placeholder tokens used in content templates
 */
export const PLACEHOLDER_TOKENS = {
  MAX_AVIOS: "{{maxAvios}}",
} as const;

/**
 * Contentful content key
 */
export const CONTENT_KEY = "boostMultiplierSharedV2" as const;

/**
 * Content delimiter for parsing list items
 */
export const TERMS_DELIMITER = "|" as const;

/**
 * Number of placeholder rows shown in the loading skeleton.
 */
export const MAX_VISIBLE_BOOST_OPTIONS = 3;

/**
 * Skeleton row heights, matching each real element's alto text-size token
 */
export const SKELETON_ROW_HEIGHT = {
  HEADING_MD: "var(--alto-sem-text-heading-md-line-height)",
  BODY_MD: "var(--alto-sem-text-body-md-line-height)",
  BODY_SM: "var(--alto-sem-text-body-sm-line-height)",
  LABEL_MD: "var(--alto-sem-text-label-md-line-height)",
} as const;
